import { Link, Navigate, useParams } from "react-router-dom";
import Acces from "./Acces";
import General from "./General";
import { useT } from "../i18n";
import type { Cheie } from "../i18n";
import "./setari.css";

/** Setările proiectului — o pagină cu secțiuni, ca setările unui depozit din
 *  Bitbucket.
 *
 *  Roata dințată s-a mutat la BAZA railului, singură, despărțită de traseele
 *  de lucru (Model → Dosar → Verificări → Costuri → Pipeline → Ramuri): ăsta e
 *  locul convențional al setărilor și e și adevărul — nu e un pas al lucrului,
 *  e ce se întâmplă în jurul lui.
 *
 *  Setările de CALCUL nu sunt aici, deși ar încăpea: au ecran propriu, pe
 *  railul de lucru, sub o pictogramă de calculator. Sunt o intrare a lanțului
 *  — le schimbi în timp ce lucrezi, nu când te ocupi de proiect ca obiect.
 *  Din 05.09.2026 sunt șase, toate despre execuția armăturii. */

const SECTIUNI: readonly { key: "general" | "access";
                          eticheta: Cheie; descriere: Cheie }[] = [
  { key: "general", eticheta: "setari.general",
    descriere: "setari.general_descriere" },
  { key: "access", eticheta: "setari.acces",
    descriere: "setari.acces_descriere" },
];

type CheieSectiune = (typeof SECTIUNI)[number]["key"];

export default function Setari() {
  const { projectId = "", sectiune } = useParams();
  const t = useT();

  // `/settings` fără secțiune deschide prima — un URL scurt care merge e mai
  // bun decât un ecran gol care cere un click ca să arate ceva.
  if (!sectiune) return <Navigate to="general" replace />;
  if (!SECTIUNI.some((s) => s.key === sectiune)) {
    return <Navigate to="general" replace />;
  }
  const activa = sectiune as CheieSectiune;

  return (
    <div className="setari">
      <nav className="setari-nav">
        <span className="lbl">{t("setari.titlu")}</span>
        {SECTIUNI.map((s) => (
          <Link key={s.key} to={`/p/${projectId}/settings/${s.key}`}
                className={`setari-nav-item${s.key === activa ? " on" : ""}`}>
            <b>{t(s.eticheta)}</b>
            <span>{t(s.descriere)}</span>
          </Link>
        ))}
      </nav>
      <div className="setari-corp">
        {activa === "general" && <General projectId={projectId} />}
        {activa === "access" && <Acces projectId={projectId} />}
      </div>
    </div>
  );
}
